export default {"src":"/_next/static/image/public/images/ic_vm_refer_earn.23d722891fdfcfc8faca3d0711c3e35b.svg","height":16,"width":18};